import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeProvider';
import { Toaster } from 'sonner';
import './i18n/config';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Portfolio from './pages/Portfolio';
import Certifications from './pages/Certifications';
import Team from './pages/Team';
import Testimonials from './pages/Testimonials';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Whistleblowing from './pages/Whistleblowing';
import WhistleblowingTrack from './pages/WhistleblowingTrack';
import WhistleblowingView from './pages/WhistleblowingView';
import CompliancePage from './pages/CompliancePage';
import CondizioniVendita from './pages/CondizioniVendita';
import CustomPage from './pages/CustomPage';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import CookieBanner from './components/ui/cookie-banner';
import './App.css';

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="gmed-theme">
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="products" element={<Products />} />
            <Route path="products/:id" element={<ProductDetail />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="certifications" element={<Certifications />} />
            <Route path="team" element={<Team />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="blog" element={<Blog />} />
            <Route path="contact" element={<Contact />} />
            <Route path="whistleblowing" element={<Whistleblowing />} />
            <Route path="whistleblowing/track" element={<WhistleblowingTrack />} />
            <Route path="whistleblowing/view/:reportId" element={<WhistleblowingView />} />
            <Route path="compliance/:type" element={<CompliancePage />} />
            <Route path="condizioni-vendita" element={<CondizioniVendita />} />
            <Route path=":slug" element={<CustomPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <CookieBanner />
      </Router>
      <Toaster position="top-right" richColors />
    </ThemeProvider>
  );
}

export default App;
